export default __webpack_public_path__ + "static/media/vert-negative.db1f01d9.svg";